import { FC, ReactNode } from "react";
import { cn } from "@utils/utils";

interface SectionWrapperProps {
  title?: string;
  children: ReactNode;
  className?: string;
  isExpertMode?: boolean;
}

export const SectionWrapper: FC<SectionWrapperProps> = ({title, children, className, isExpertMode}) => (
  <div
    className={cn(
      "mp-6 bg-gray-100 p-6 rounded-md",
      isExpertMode && "bg-metallic-200",
      className,
    )}
  >
    {title ? <h3 className="text-lg font-medium mb-4">{title}</h3> : null}
    <div className="pl-2 flex flex-col gap-4">{children}</div>
  </div>
);
